import Banner from "./banner";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Autoplay } from "swiper/modules";

export default function BannersCase({ banners, isMobile }: { banners: {}[], isMobile: boolean }) {

    return (
        <div className="py-12 overflow-hidden">
            <Swiper
                modules={[Autoplay]} 
                autoplay={{ delay: 4000, disableOnInteraction: false }}
                className="max-w-5xl w-full !overflow-visible"
                slidesPerView="auto"
                centeredSlides={true}
                spaceBetween={-30}
                grabCursor={true}
                loop
                speed={800}
            >
                {
                    banners.map((b, i) => (
                        <SwiperSlide key={i} style={{ width: 280 }}>
                            <Banner banner={b} />
                        </SwiperSlide>
                    ))
                }
            </Swiper>
        </div>
    )
}
